import { createReducer } from '@reduxjs/toolkit'; // TODO: import from `~/lib/redux` instead
import { MAP_COLOR } from '../../lib/constants';
import { getArea, getAreaBoundaries, getAreaTeams } from '../../redux';
const initialState = {
    area: {
        area: null,
        error: null,
        isLoading: false,
    },
    boundaries: {
        areaBoundaries: null,
        error: null,
        isLoading: false,
    },
    teams: {
        areaTeams: [],
        error: null,
        isLoading: false,
    },
    teamZips: {
        error: null,
        isLoading: false,
    },
};
const area = createReducer(initialState, (builder) => {
    builder
        .addCase(getArea.request, (state) => {
        state.area.isLoading = true;
        state.area.error = null;
    })
        .addCase(getArea.success, (state, action) => {
        const { data: { area_id: id, area_name: name } } = action.payload;
        state.area.area = {
            id,
            name,
        };
        state.area.isLoading = false;
    })
        /*.addCase(getArea.failure, (state, action) => {
          state.area.error = action.payload;
          state.area.isLoading = false;
        })*/
        .addCase(getAreaBoundaries.request, (state) => {
        state.boundaries.isLoading = true;
        state.boundaries.error = null;
    })
        .addCase(getAreaBoundaries.success, (state, action) => {
        const { data: { boundary, center } } = action.payload;
        state.boundaries.areaBoundaries = {
            boundaries: boundary,
            center: {
                type: 'Point',
                coordinates: [center.longitude, center.latitude],
            },
        };
        state.boundaries.isLoading = false;
    })
        /*.addCase(getAreaBoundaries.failure, (state, action) => {
           state.boundaries.error = action.payload;
           state.boundaries.isLoading = false;
         })*/
        .addCase(getAreaTeams.request, (state) => {
        state.teams.isLoading = true;
        state.teams.error = null;
    })
        .addCase(getAreaTeams.success, (state, action) => {
        state.teams.areaTeams = action.payload.data.map(({ team_id: id, name: name, team_leaders: teamLeaders, total_reps: totalReps, percentage_assigned: percentageAssigned, total_addresses: totalAddresses, total_qualified_addresses: qualifiedAddresses, active_customers: activeCustomers, inactive_customers: inactiveCustomers, }, index) => ({
            id,
            name,
            color: MAP_COLOR.TEAM_COLORS[index % MAP_COLOR.TEAM_COLORS.length],
            teamLeaders,
            totalReps,
            percentageAssigned,
            qualifiedAddresses,
            totalAddresses,
            activeCustomers,
            inactiveCustomers,
        }));
        state.teams.isLoading = false;
    })
        /*.addCase(getAreaTeams.failure, (state, action) => {
           state.teams.error = action.payload;
           state.teams.isLoading = false;
         })*/
        .addMatcher((action) => action.type.match(/@@SALES_PLANNING_TOOL\/(UN)?ASSIGN_TEAM_ZIPS_REQUEST/), (state) => {
        state.teamZips.isLoading = true;
        state.teams.error = null;
    })
        .addMatcher((action) => action.type.match(/@@SALES_PLANNING_TOOL\/(UN)?ASSIGN_TEAM_ZIPS_SUCCESS/), (state) => {
        state.teamZips.isLoading = false;
    });
});
export default area;
